import type { UmbUnsupportedEditorSchemaAliases } from '../types/index.js';

export const UMB_UNSUPPORTED_EDITOR_SCHEMA_ALIASES: UmbUnsupportedEditorSchemaAliases = {
	block: ['Umbraco.ImageCropper', 'Umbraco.UploadField'],
};
